<template>
    <div id="bene-list-container">
      <f7-searchbar search-container=".beneficiary-list-2" search-in=".item-title" placeholder="Search recipient" id="bene-search-bar"></f7-searchbar>

      <f7-list class="searchbar-not-found">
        <f7-list-item title="Nothing found"></f7-list-item>
      </f7-list>

      <f7-list no-hairlines class="beneficiary-list-2 searchbar-found no-outlines">
        <f7-list-item v-for="item in beneficiaryList" :key="item.beneficiaryId"  @click="test()" class="list-content-row">

          <div class="row no-gap w-100">
            <div class="col-bank" style="">
              <img :src="require('@/assets/img/bank/' + item.bankId +'.jpg')"/>
            </div>
            <div class="col-details" :class="item.dmId == 1 ? ' editable ' : ' ' ">
              <div class="item-title">{{item.firstName}}</div>
              <div class="wandr-caption-2" style="">
                {{item.bankName}}&nbsp;{{item.bankAccountNo}}
              </div>
            </div>
            <div class="col-country">
              <img class="elevation-2" :src="require('@/assets/img/flags/flag_circle_small_' + item.homeCountryId +'.png')"/>
            </div>
            <div class="col-edit" v-show="item.dmId == 1">
              <img :src="require('@/assets/img/icon/icon-pencil.svg')" class="">
            </div>
          </div>
          
        </f7-list-item>
      </f7-list>
    </div>
</template>

<script>

  export default {
    props: ['isSearchBar'],
    mounted (){
      if(!this.isSearchBar){
        let $$ = this.Dom7;
        $$("#bene-search-bar").addClass("hidden-by-searchbar")
      }
    },
    data: function () {
      return {
        beneficiaryList: [
          {'id': 1, 'homeCountryId': 99, 'homeCurrency' : 'IDR', 'dmId' : 2, 'dmName' : 'Bank Transfer', 'bankId' : 58, 'bankName' : 'Bank A', 'bankAccountNo' : 123456789012345, 'firstName' : 'Josh Lovuid' },
          {'id': 2, 'homeCountryId': 44, 'homeCurrency' : 'CNY', 'dmId' : 1, 'dmName' : 'Bank Transfer', 'bankId' : 118, 'bankName' : 'Bank B', 'bankAccountNo' : 9801234567, 'firstName' : 'Friends' },
          {'id': 3, 'homeCountryId': 128, 'homeCurrency' : 'MYR', 'dmId' : 2, 'dmName' : 'Bank Transfer', 'bankId' : 184, 'bankName' : 'Bank B Bank B Bank B Bank B Bank B Bank B', 'bankAccountNo' : 986374658763, 'firstName' : 'Friends 2 Friends 2 Friends 2 Friends 2 Friends 2 Friends 2 Friends 2 Friends 2 Friends 2' },
          {'id': 4, 'homeCountryId': 128, 'homeCurrency' : 'MYR', 'dmId' : 1, 'dmName' : 'Bank Transfer', 'bankId' : 184, 'bankName' : 'Bank B Bank B Bank B Bank B Bank B Bank B Bank B', 'bankAccountNo' : 986374658763, 'firstName' : 'Friends 2 Friends 2 Friends 2 Friends' }
        ],
      }
    },
    computed: {
      
    },
    methods: {
      test(){
        alert("test")
      }
    }
  }
</script>